
/**
 * 
 * @param {NodeListOf<HTMLElement>} inputs
 */
export function setFocus(inputs) {
    for (let input of inputs) {
        input.addEventListener('focus', () => {
            setTimeout(() => {
                input.select(); // Seleccionar todo el contenido
            }, 180)
        });
    }
}

/**
 * 
 * @param {NodeListOf<HTMLElement>} inputs
 * @param {number} max
 * @param {number} min
 */
export function setInputLimits(inputs, max, min) {
    for (var input of inputs) {
        input.addEventListener('input', () => {
            const value = parseInt(input.value, 10);
            if (value > max) {
                input.value = max;
            } else if (value < min) {
                input.value = min;
            }
        });
    }
}
